
import { computed, defineComponent} from 'vue'
import { useStore } from '@/store'
import ThumbnailSlide from '@/views/components/ThumbnailSlide/index.vue'
export default defineComponent({
  name: 'thumbnails',
  components: {
    ThumbnailSlide,
  },
  setup() {
    const store = useStore()
    const slides = computed(() => store.state.slides)
    const width = 400
    return {
      slides,
      width
    }
  },
})
